<template>
  <div class="h100pc">
    <img
        class="back"
        @click="goHome"
        v-lazy="require('./../../../assets/img/back2.png')"
      />
    <div class="hd bggray">
      <span class="hd_span f16"> 我的订单</span>
      <div class="input" @click="openValue">
        <div class="f14 select">
          <span class="select_txt">{{ selected }}</span>
          <img src="./../../../assets/img/test/down-arrow-1.png" alt="" />
        </div>
        <div class="list" v-show="show">
          <div class="flex" @click="getFatherValue">
            <span
              :class="item.text == selected ? 'li active' : 'li'"
              :key="item.value"
              v-for="item in categoricals"
              :data-val="item.value"
              :data-txt="item.text"
              >{{ item.text }}</span
            >
          </div>
        </div>
      </div>
    </div>

    <div class="testlist">
      <div class="overlay" v-if="show" @click="openValue"></div>
      <NoPic style="margin-top: 50%" v-if="!testLen"></NoPic>
      <van-pull-refresh v-model="isDownLoading" @refresh="onDownRefresh">
        <van-list
          v-model="isUpLoading"
          :finished="upFinished"
          :immediate-check="false"
          :offset="5"
          finished-text="我是有底线的"
          @load="onLoadList"
        >
          <div class="cardBox">
            <div class="content">
              <div v-for="(item, index) in nTests" :key="index">
                <div>
                  <div
                    class="card mb-20"
                    @click="gotoDetail(item.evaluation.id)"
                    v-if="item"
                  >
                    <div class="card_imgBox">
                      <img
                        v-lazy="item.evaluation.classify_image"
                        class="testImg"
                      />
                    </div>
                    <div class="detail">
                      <p class="h2">
                        {{ item.evaluation.title
                        }}<span class="price">￥{{ item.actual_amount }}</span
                        ><br /><span class="status">{{
                          item.is_payed_name
                        }}</span>
                      </p>
                      <p></p>
                      <p>
                        <span class="time">{{
                          item.created_at.slice(0, 10)
                        }}</span>
                        <b
                          v-if="item.is_payed_name == '未支付'"
                          class="watch"
                          @click="gotoDetail(item.evaluation.id)"
                          >去付款</b
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import NoPic from "@/components/NoPic";
import { getMycollection, getAllCat, myOrder } from "@/http/api";
import { mapGetters } from "vuex";
import store from "./../../../store/index";
export default {
  name: "myOrder",
  data() {
    return {
      value: "",
      show: false,
      selected: "全部分类",
      categoricals: [
        {
          value: "",
          text: "全部分类",
        },
      ],
      nTests: [],
      testLen: 0,

      // 分页
      total: 0,
      pageSize: 1000, // 每页条数
      pageIndex: 1, // 页码
      isDownLoading: false, // 下拉刷新
      isUpLoading: false, // 上拉加载
      upFinished: false, // 上拉加载完毕
      offset: 100, // 滚动条与底部距离小于 offset 时触发load事件
    };
  },
  watch: {
    categoricals(val) {
      this.categoricals = val;
    },
  },
  computed: {
    // ...mapGetters(['user_id'])
  },
  created() {
    getAllCat().then((res) => {
      this.categoricals = this.categoricals.concat(
        res.data.objects.map((u, i) => {
          return {
            text: u.name,
            value: u.id,
          };
        })
      );
      console.log(this.categoricals);
      this.selected = this.categoricals[0].text;
      //   this.couponSelected = this.couponList[0].id;
      this.getroadList();
    });
  },
  methods: {
    goHome() {
      this.$router.push("/my/center");
    },
    // 模拟select组件
    gotoDetail(id) {
      // console.log(id, 'goto')
      store.commit("set_eval_id", id);
      this.$router.push("/test/" + id);
    },
    openValue() {
      this.show = !this.show;
      console.log(this.categoricals);
    },
    // getValue(index, item) {
    //     console.log("获取", item);
    //     let params = {
    //         page: this.pageIndex,
    //         page_size: this.pageSize,
    //     };
    //     if (item) {
    //         this.value = item.value;
    //         this.selected = item.text;
    //         params.evaluation_type = this.value;
    //     }
    //     console.log("获取分类", params);
    //     myOrder(params).then((res) => {
    //         console.log("我的收藏", res, this.selected);
    //         // if(this.selected==='全部分类'){
    //         //  this.nTests = this.nTests.concat(res.data.objects)
    //         // }
    //         // else{
    //         this.nTests = res.data.objects;
    //         // }
    //     });
    // },
    getFatherValue(e) {
      if (e.target.localName == "span") {
        let item = e.target.dataset;
        console.log(item);
        // console.dir(id);
        let params = {
          page: this.pageIndex,
          page_size: this.pageSize,
        };
        if (item) {
          this.value = item.val;
          this.selected = item.txt;
          params.evaluation_type = item.val;
        }
        console.log("获取分类", params);
        myOrder(params).then((res) => {
          console.log("我的收藏", res, this.selected);
          // if(this.selected==='全部分类'){
          //  this.nTests = this.nTests.concat(res.data.objects)
          // }
          // else{
          this.nTests = res.data.objects;
          // }
        });
      }
    },
    getroadList(item) {
      let params = {
        page: this.pageIndex,
        page_size: this.pageSize,
      };
      if (item) {
        this.value = item.value;
        this.selected = item.text;
        params.evaluation_type = this.value;
      }
      myOrder(params)
        .then((res) => {
          console.log("请求", res);
          this.total = res.data.count;
          if (res.data.objects) {
            this.nTests = this.nTests.concat(res.data.objects);
            this.testLen = this.nTests.length;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.isDownLoading = false;
          this.isUpLoading = false;
        });
    },
    // 下拉刷新
    onDownRefresh() {
      this.nTests = [];
      this.pageIndex = 1;
      this.upFinished = false; // 不写这句会导致你上拉到底过后在下拉刷新将不能触发下拉加载事件
      this.getroadList(); // 加载数据
    },
    // 上拉加载请求方法
    onLoadList() {
      if (this.total > this.pageIndex * this.pageSize) {
        this.pageIndex++;
        this.getroadList();
      } else {
        this.upFinished = true;
      }
    },
  },
  components: {
    // TestList,
    NoPic,
  },
};
</script>

<style lang="less" scoped>
@import "~Style/index.less";
.back {
  width: 22px;
  height: 23px;
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
  left: 5px;
  top: 5px;
}
.card {
    width: 100%;
    display: flex;

    .card_imgBox {
        .w(120);
        height: 96px;
    }

    .testImg {
        width: 100%;
        border-radius: 12px;
        height: 100%;
    }

    .detail {
        width: 70%;
        margin-left: 17px;
        font-size: 15px;
        text-align: start;
        padding-top: 10px;

        .h2 {
            height: 1.6rem;
            line-height: 0.586667rem;
        }

        .price {
          margin-right:10px;
          float:right;
            font-size: 15px;
            font-family: SourceHanSansCN-Medium, SourceHanSansCN;
            font-weight: 500;
            color: #F5A623;
            line-height: 23px;
        }

        .discount {
            color: gray;
            font-size: smaller;
        }

        .status {
            font-size: 10px;
            font-family: SourceHanSansCN-Normal, SourceHanSansCN;
            font-weight: 400;
            color: #F5A623;
        }

        .time {
            font-siz e: 10px;
            font-family: SourceHanSansCN-Normal, SourceHanSansCN;
            font-weight: 400;
            color: #4A4A4A;
            line-height: 15px;
        }

        .watch {
            float: right;
            margin-right: 10px;
            font-size: 12px;
            display: inline-block;
            width: 78px;
            height: 20px;
            background: #42686E;
            border-radius: 8px;
            font-size: 13px;
            font-family: SourceHanSansCN-Medium, SourceHanSansCN;
            font-weight: 500;
            color: #FFFFFF;
            text-align: center;
            line-height: 20px;
            letter-spacing: 1px;
        }
    }
}

html,
body {
    height: 100%;
}

.hd {
    height: 40px;
    // line-height: 40px;
    display: flex;
    justify-content: space-between;

    .hd_span {
        margin-left: 40px;
        line-height: 40px;
    }

    .input {
        // display: inline-block;
        // width: 30%;
        // float: right;
        // position: relative;
        // font-size: small;
        // text-align: center;
    }

    .select {
        height: 100%;
        font-weight: bold;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 30px;

        .select_txt {
            display: inline-block;
            height: 14px;
            margin-right: 5px;
        }

        img {
            width: 7px;
            height: 7px;
        }
    }

    .list {
         position: absolute;
        top: 40px;
        left: 0;
        z-index: 2;
        // border-radius: 0 0 10px 10px;
        background: #F9F9F9;
        width: 100vw;
        padding: 32px 5px;
        padding-bottom:10px;
        .flex {
            display: flex;
            flex-wrap: wrap;

            .li {
                display: block;
                text-align: center;
                width: 65px;
                height: 28px;
                background: #fff;
                border-radius: 2px;
                border: 2px solid #000000;
                font-size: 13px;
                font-family: SourceHanSansCN-Regular, SourceHanSansCN;
                font-weight: 400;
                color: #4A4A4A;
                line-height: 24px;
                margin-right:12px;
                margin-left:13px;
                margin-bottom:15px;
            }

            .active {
                width: 65px;
                height: 28px;
                background: #42686E;
                border-radius: 2px;
                color:#fff;
            }
        }

        li {
            font-size: 16px;
            line-height: 34px;
            color: #d6d6d6;
            text-align: center;

            hr {
                margin: 0;
            }
        }

        li:last-child {
            hr {
                display: none;
            }
        }
    }
}

.testlist {
    height: 92%;
    // min-height: 15rem;
    width: 100%;
    // overflow: scroll;
    position: relative;
    padding-top: 20px;

    .overlay {
        position: fixed;
        top: 40px;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.6);
        z-index: 1;
    }
}

.cardBox {
    padding: 0 22px;
}
</style>
